/** @format */

import {Box, Dialog} from '@mui/material';
import {styled} from '@mui/material/styles';

export const SidebarRoot = styled(Box)(({theme}) => ({
  width: '280px',
  minWidth: '280px',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.semantic_dark?.surface.surface1,
  borderRight: `1px solid ${theme.palette.semantic_dark?.surface.surface2}`,
  overflowY: 'auto',
  overflowX: 'hidden',
}));

export const NewChatButtonContainer = styled(Box)(({theme}) => ({
  padding: theme.spacing(3),
}));

export const ChatList = styled(Box)(() => ({
  flex: 1,
  overflowY: 'auto',
}));

interface ChatItemProps {
  isActive: boolean;
}

export const ChatItem = styled(Box, {
  shouldForwardProp: prop => prop !== 'isActive',
})<ChatItemProps>(({theme, isActive}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 3),
  cursor: 'pointer',
  backgroundColor: isActive ? theme.palette.semantic_dark?.surface.surface2 : 'transparent',

  '&:hover': {
    backgroundColor: theme.palette.semantic_dark?.surface.surface2,

    '& .chat-actions': {
      display: 'flex',
    },
  },

  ...(isActive && {
    '& .chat-actions': {
      display: 'flex',
    },
  }),
}));

export const ChatTitle = styled(Box)(() => ({
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '14px',
}));

export const ChatActions = styled(Box)(({theme}) => ({
  display: 'none',
  gap: theme.spacing(1),
  marginLeft: theme.spacing(1),
  flexShrink: 0,
}));

export const DeleteDialog = styled(Dialog)(({theme}) => ({
  '& .MuiDialog-paper': {
    background: theme.palette.semantic_dark?.surface.surface2,
    color: theme.palette.semantic_dark?.surface.onSurface,
    borderRadius: '16px',
  },
  '& .MuiDialogTitle-root': {
    color: theme.palette.semantic_dark?.surface.onSurface,
  },
  '& .MuiDialogContentText-root': {
    color: theme.palette.semantic_dark?.surface.onSurfaceLight,
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(4),
  },
}));

export const RenameContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  flex: 1,
}));
